module.exports = __webpack_public_path__ + "img/christmas_glitter.dfdc71f5.jpg";